var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",style:({'font-size':_vm.fontSize,'background':_vm.background}),on:{"click":function($event){return _vm.onClick()}}},[_c('use',{attrs:{"xlink:href":'#icon-' + _vm.type}})])
}
var staticRenderFns = []

export { render, staticRenderFns }